import React from 'react';
import { connect } from 'react-redux';
import { guardarPreguntas } from './servicios.act';
import { movil } from '../app-movil';
import { cambiarPreguntas, cambiarPreguntasDesbloqueo } from './datos.act';
import { goTo } from "../tools";

const mapState = (state) => {
    return {
    	preguntaUnoEdit: state.miPerfil.preguntaUnoEdit,
		respuestaUnoEdit: state.miPerfil.respuestaUnoEdit,
		preguntaDosEdit: state.miPerfil.preguntaDosEdit,
		respuestaDosEdit: state.miPerfil.respuestaDosEdit,
		loadLocal: state.miPerfil.loadLocal,
		dispositivo: state.global.dispositivo
    };
}

const mapDispatch = (dispatch) => {
    return {
    	resetSiguientePreguntas: () => {
            dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_PREGUNTAS" });
        },
        pasoSiguientePreguntas: () => {
            dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_PREGUNTAS" });
        },
        cambiarPreguntas: (datos) => {
            dispatch(cambiarPreguntas(datos));
        },
        cambiarPreguntasDesbloqueo: (datos) => {
            dispatch(cambiarPreguntasDesbloqueo(datos));
        },
        setloadLocal: (val) => {
            dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", load: val });
        }
    }
}

class PasoDosPreguntas extends React.Component {
	state = {
		inputClassContrasenaPreguntasEdit: "input-wrap",
		inputActiveContrasenaPreguntasEdit: "",
		inputContrasenaPreguntasEditType: "password",
		errroContrasenaEditPreguntas: false,
		contrasenaPreguntasEdit: "",
		error: false,
		msjError: "",
	}

    goToLogin = () =>{
		//$("#modal-user-bloqueado").modal("toggle");
        $('#modal-editar-preguntas').modal('toggle');
		this.props.resetPaso();
	}

	handleFocus = (event) => {
		let id = event.target.id;
        switch(id) {
        	case "inputContrasenaPreguntasEdit":
                this.setState({inputActiveContrasenaPreguntasEdit: "input-active"});
                break;
        }
	}
	handleBlur = (event) => {
		let id = event.target.id;
        let valor = event.target.value;
        switch(id) {
        	case "inputContrasenaPreguntasEdit":
                this.setState({inputActiveContrasenaPreguntasEdit: valor ? "input-active" : ""});
                this.setState({contrasenaPreguntasEdit: valor});
                break;
        }
	}
	toggleType = (event) => {
		let id = event.target.id;
        let type;
        switch(id) {
        	case "ojoContrasenaPreguntasEdit":
                type = this.state.inputContrasenaPreguntasEditType;
                this.setState({inputContrasenaPreguntasEditType: type == "password" ? "text" : "password"});
                this.setState({inputClassContrasenaPreguntasEdit: type == "password" ? "input-wrap" : "input-wrap"});
                break;
        }
	}
	
	okPreguntas = () => {
        let mensaje = {"return": "miPerfil", "proceso": "cambioPreguntas"};
        movil("cambioPreguntas", mensaje);
        this.props.resetSiguientePreguntas();
        this.setState({inputClassPreguntaUno: "input-wrap ver-input"});
        this.setState({inputClassPreguntaDos: "input-wrap ver-input"});
        this.setState({inputClassContrasenaPreguntasEdit: "input-wrap ver-input"});
        this.setState({inputActivePreguntaUnoEdit: ""});
        this.setState({inputActivePreguntaDosEdit: ""});
        this.setState({inputActiveContrasenaPreguntasEdit: ""});
        this.setState({inputPreguntaUnoType: "password"});
        this.setState({inputPreguntaDosType: "password"});
        this.setState({inputContrasenaPreguntasEditType: "password"});
        this.setState({respuestaUnoEdit: ""});
        this.setState({RespuestaDosEdit: ""});
        this.setState({contrasenaPreguntasEdit: ""});
        $('#modal-editar-preguntas').modal('toggle');
    }

    setPreguntas = () => {
        let obj = {
            p1: this.props.preguntaUnoEdit,
            r1: this.props.respuestaUnoEdit,
            p2: this.props.preguntaDosEdit,
            r2: this.props.respuestaDosEdit,
            pass: this.state.contrasenaPreguntasEdit
        }

        if(this.refs.pass.value == ""){
            this.setState({error: true})
            this.setState({msjError: "Campo requerido"})
        }
        else{
            console.log("Cambiará preguntas desde perfil");
            //console.log(obj);
            this.props.setloadLocal(true);
            obj.dispositivo = this.props.dispositivo;
            this.props.cambiarPreguntas(obj);
        }
    }
    setPreguntasDesbloqueo = () => {
        //console.log(localStorage.getItem("clienteUnico"));
        const clienteU = localStorage.getItem("clienteUnico");
        //console.log("clienteU", clienteU);
        let obj = {
            p1: this.props.preguntaUnoEdit,
            r1: this.props.respuestaUnoEdit,
            p2: this.props.preguntaDosEdit,
            r2: this.props.respuestaDosEdit,
            pass: this.state.contrasenaPreguntasEdit,
            clienteUnico: clienteU
        }

        if(this.refs.pass.value == ""){
            this.setState({error: true})
            this.setState({msjError: "Campo requerido"})
        }
        else{
            //console.log("Cambiará preguntas desbloqueo");
            //console.log(obj);
            this.props.setloadLocal(true);
            obj.dispositivo = this.props.dispositivo;
            this.props.cambiarPreguntasDesbloqueo(obj);
            //Desbloquear usuario service
        //console.log("aqui va el debloqueo");
        //$this.props.resetPaso();
        //goTo("login");
        //goToLogin();
        }

        
    }

	render() {
		return <div>
            <h5>
                <i>
                    <img src={ require("../img/icon-question.png") } />
                </i>Actualizar preguntas secretas
            </h5>
            { this.state.errroContrasenaEditPreguntas &&
                <div className="msj-warning">
                    <i className="no-pad"><img src={ require("../img/exclamation-naranja.png") } /></i>
                    <span>
                        Tu contraseña no coincide. Favor de verificar.
                    </span>
                </div>
            }
            <hr className="mt-34" />
            { this.props.loadLocal &&
            <div className="table-center">
                     <img src={ require("../img/load_mini.gif") } />
            </div>
            }
            { !this.props.loadLocal &&
            <div>
            <div className="texto-17">
                <p>Captura la contraseña con la que ingresas al Portal Soy Cliente.</p>
            </div>
            <div className="row">
                <div className="col-xs-12 col-md-10 col-md-offset-1">
                    <div className="row">
                        <div className="col-xs-12 mt-50">
                            <div className={this.state.inputClassContrasenaPreguntasEdit}>
                                <label>Contraseña</label>
                                <span className={this.state.inputActiveContrasenaPreguntasEdit}>
                                    <input ref="pass" id="inputContrasenaPreguntasEdit" type={this.state.inputContrasenaPreguntasEditType} onFocus={this.handleFocus} onBlur={this.handleBlur} />
                                    {/*<button id="ojoContrasenaPreguntasEdit" className="btn-ojo" onClick={this.toggleType}></button>*/}
                                </span>
                                { this.state.error &&
                                    <div className="error-wrap">
                                        <div className="msj-error">
                                            <p>{this.state.msjError}</p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        { !localStorage.hasOwnProperty('clienteUnico') &&
                        <div className="col-xs-12">
                            <div className="text-center aceptar-cancelar-btn mt-50">
                                <a onClick={this.okPreguntas}>Cancelar</a>
                                <a className="orange-btn" onClick={this.setPreguntas}>Siguiente</a>
                            </div>
                        </div>
                        }
                        { localStorage.hasOwnProperty('clienteUnico') &&
                        <div className="col-xs-12">
                            <div className="text-center aceptar-cancelar-btn mt-50">
                                <a onClick={this.okPreguntas}>Cancelar</a>
                                <a className="orange-btn" onClick={this.setPreguntasDesbloqueo}>Siguiente</a>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            </div>
            }
        </div>
	}
}

export default connect(mapState, mapDispatch)(PasoDosPreguntas);


// WEBPACK FOOTER //
// ./src/miPerfil/pasoDosPreguntas.cmpt.js